<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('forthing.history.title-label') }}</h3>
        </div>

        <div v-if="(! transactions)">
            <p class="card-text m-0 p-0 mt-2 pb-4">
                {{ $t('loading') }}
            </p>
        </div>

        <div class="container center-items text-center">
            <div v-if="(transactions)">
                <div class="container center-items m-0 p-0 mt-4">
                    <div class="check_color_position">
                        <i class="fa fa-check-circle fa-lg aube_user_wallet_check_color"></i>{{ $t('forthing.history.aube_user_wallet_check_color') }}</br>
                        <i class="fa fa-check-circle fa-lg hec_saving_check_color"></i>{{ $t('forthing.history.hec_saving') }}
                    </div>
                    <table class="table table-striped forthing-table">
                        <thead>
                            <tr class="bg-primary">
                                <th scope="col" class="text-left text-white border-0">
                                    {{ $t('forthing.history.date-label') }}
                                </th>
                                <th scope="col" class="text-left text-white border-0">
                                    {{ $t('forthing.history.volume-label') }}
                                </th>
                                <th scope="col" class="text-center text-white border-0">
                                    {{ $t('forthing.history.paid-label') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="transaction in transactions" v-bind:key="transaction.id">
                                <td class="text-left">
                                    {{ transaction.created_at | moment('YYYY/MM/DD') }} (SGT)
                                </td>
                                <td class="text-left">
                                    {{ transaction.amount | round }}
                                </td>
                                <td class="text-center text-success">
                                    <div v-if="transaction.status === 'STATUS_SUCCESS'">
                                        <div v-if="[two_years_plan_address, two_years_plan_rokes_address].includes(transaction.to_address)">
                                            <i class="fa fa-check-circle fa-lg hec_saving_check_color"></i>
                                        </div>
                                        <div v-else>
                                            <i class="fa fa-check-circle fa-lg aube_user_wallet_check_color"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- ページネーション -->
            <div class="container center-items text-center m-0 p-0 mt-5">
                <paginate v-bind:pagination="pagination" v-on:change-page="fetch(true)"></paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import tokenService from './../../services/TokenService';
    import Paginate from './../../components/Paginate';
    import UserService from './../../services/UserService';

    export default {
        name: 'TokenBalances',

        components: {
            Paginate,
        },

        data() {
            return {
                transactions: undefined,
                pagination: {
                    total_pages: 0,
                    current_page: 1,
                    per_page: 20,
                    total: 0,
                },
                two_years_plan_address: undefined,
                two_years_plan_rokes_address: undefined,
            }
        },

        mounted() {
            this.fetch();
        },

        created() {
        },

        methods: {
            async fetch(scrollToTop = false) {
                const params = {
                    page: this.pagination.current_page,
                    size: this.pagination.per_page,
                };

                //2年アドレスを取得
                const data = (await UserService.getHecSavingApplyInfo()).data;
                this.two_years_plan_address = data.two_years_plan_address
                this.two_years_plan_rokes_address = data.two_years_plan_rokes_address

                let [ txs ] = await Promise.all([
                    tokenService.getForthingTransactions(params),
                ]);

                // トランザクションを設定
                this.transactions = [];
                for (let i in txs.data) {
                    if (txs.data.hasOwnProperty(i) && i !== 'meta') {
                        this.transactions.push(txs.data[i]);
                    }
                }

                // メタデータを設定
                this.pagination = txs.data.meta.pagination;

                // 場合に応じて (0, 0) にスクロールする
                if (scrollToTop) {
                    window.scrollTo(0, 0);
                }
            }
        }
    }
</script>

<style scoped>
    .balanceBlock {
        display: flex;
        justify-content: space-between;
    }
    .forthing-table {
        border-collapse: separate;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        overflow: hidden;
    }
    .center-items {
        width: 100%;
        margin: 0 auto;
    }
    .aube_user_wallet_check_color {
       color: #450080;
    }
    .hec_saving_check_color {
       color: #00ad69;
    }
    .check_color_position {
        text-align: left;
    }
</style>
